exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-auth[data-v-743ef546]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-size:12px;background:#fff}.company-auth[data-v-743ef546],.header[data-v-743ef546]{display:-webkit-box;display:-ms-flexbox;display:flex}.header[data-v-743ef546]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:106px;padding:0 98px;background:#f5faff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports
